import { LandlordPaymentModel } from '@evimo/types/enums/landlord-payment-model';
import { OemRateWindowUnit } from '@evimo/types/enums/oem-rate-window-unit';
import { SlaContractStatus } from '@evimo/types/enums/sla-contract-status';

export const SLA_PARTNER_KIND_COLORS = {
  landlord: '#1e6df6',
  oem: '#7c3aed',
} as const;

export const SLA_CONTRACT_STATUS_COLORS: Record<SlaContractStatus, string> = {
  [SlaContractStatus.ACTIVE]: '#00a87e',
  [SlaContractStatus.DRAFT]: '#94a3b8',
  [SlaContractStatus.INACTIVE]: '#ec7e00',
  [SlaContractStatus.EXPIRED]: '#e23b4a',
};

export const SLA_PAYMENT_MODEL_COLORS: Record<LandlordPaymentModel, string> = {
  [LandlordPaymentModel.ANNUAL]: '#1e6df6',
  [LandlordPaymentModel.MONTHLY]: '#00a87e',
  [LandlordPaymentModel.PER_CP]: '#7c3aed',
};

export const SLA_RATE_WINDOW_UNIT_COLORS: Record<OemRateWindowUnit, string> = {
  [OemRateWindowUnit.DAY]: '#1e6df6',
  [OemRateWindowUnit.HOUR]: '#ec7e00',
};

export function getSlaContractStatusColor(status: string): string {
  return SLA_CONTRACT_STATUS_COLORS[status as SlaContractStatus] ?? '#94a3b8';
}
